export const LOGOUT_URL =
  process.env.REACT_APP_LOGOUT_URL ||
  "https://loggain.studentlitteratur.se/logout.php"
export const PROFILE_URL =
  process.env.REACT_APP_PROFILE_URL ||
  "https://minbokhylla.studentlitteratur.se/profil"
export const BOOKSHELF_URL =
  process.env.REACT_APP_BOOKSHELF_URL ||
  "https://minbokhylla.studentlitteratur.se/#"
